import React from "react";

import KanbanCardSummary, {
  KanbanCardSummaryProps
} from "@atoms/KanbanCardSummary";

import { KanbanBasicCardContainer } from "./styles";

export interface KanbanBasicCardProps {
  summaryProps: KanbanCardSummaryProps;
  onClick?: () => void;
}

const KanbanBasicCard: React.FC<KanbanBasicCardProps> = ({
  summaryProps,
  onClick
}) => {
  const {
    title1,
    title2,
    description1,
    description2,
    description3,
    iconPath,
    primarycolor
  } = summaryProps;

  return (
    <KanbanBasicCardContainer onClick={onClick}>
      <KanbanCardSummary
        title1={title1}
        title2={title2}
        description1={description1}
        description2={description2}
        description3={description3}
        iconPath={iconPath}
        primarycolor={primarycolor}
      />
    </KanbanBasicCardContainer>
  );
};

KanbanBasicCard.defaultProps = {
  onClick: () => {
    /** empty */
  }
};

export default KanbanBasicCard;
